import React, { Fragment, ReactElement } from "react";
import { useParams, useLocation, useSearchParams, Link } from "wouter";

import { MiniTransactionForm, NewMiniTransactionButton } from "../MiniTransactionForm";
import { PortfolioManager } from "./PortfolioManager";
import { miniTransactionTypes } from "../MiniTransactionForm";
import { Panel } from "../../../../components/src/common/Panel";

export function PortfolioManagerPage(): ReactElement {
    const { id: clientId } = useParams<{ id: string }>();
    const [location] = useLocation();
    const [pathname] = location.split("?");
    const [queryArgs, setQueryArgs] = useSearchParams();

    let pmPageClassName = "pm-page pm-zone-style-fancy";
    if (queryArgs.get("pmStyle") === "classic") {
        pmPageClassName = "pm-page pm-zone-style-classic";
    }

    let id: string = null;
    if (queryArgs.get("id")) {
        id = queryArgs.get("id");
    }
    let type = miniTransactionTypes[0];

    if (id && id.startsWith("new")) {
        type = miniTransactionTypes.find((d) => d.toLowerCase() === id.substring(3, id.length));

        id = "new";
    }

    const handleDismiss = () => {
        const newQueryArgs = new URLSearchParams(queryArgs);
        newQueryArgs.delete("id");
        newQueryArgs.delete("parentId");
        setQueryArgs(newQueryArgs);
    };

    const endDate = queryArgs.get("endDate");
    const bondsHref = endDate ? `/bonds?date=${endDate}` : "/bonds";
    const swaptionsHref = endDate ? `/swaptions?date=${endDate}` : "/swaptions";

    return (
        <Fragment>
            <div className={pmPageClassName}>
                <div className="pm-page-header">
                    <div className="flex flex-wrap gap-2">
                        <Link href={swaptionsHref} className="pm-page-link">
                            Swaptions
                        </Link>
                        <Link href={bondsHref} className="pm-page-link">
                            Bonds
                        </Link>
                    </div>
                    <NewMiniTransactionButton page={pathname} queryArgMode={true} />
                </div>
                <div className="pm-page-body">
                    <PortfolioManager />
                </div>
                <Panel isOpen={id != null} onDismiss={handleDismiss}>
                    {id ? (
                        <MiniTransactionForm
                            clientId={clientId}
                            id={id === "new" ? null : id}
                            type={id === "new" ? type : null}
                            parentId={
                                queryArgs.get("parentId") && (type === "CloseDerivativeTrade" || type === "ExpiryDerivativeTrade")
                                    ? queryArgs.get("parentId")
                                    : null
                            }
                            queryArgMode={true}
                            showHeader
                        />
                    ) : null}
                </Panel>
            </div>
        </Fragment>
    );
}
